import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { OdspRecentFilesAction } from '../../domains/odspRecentFiles/actions.types';

import type { OdspRecentFilesRequest } from './types';

export type { OdspRecentFilesAction };

const initialState: OdspRecentFilesRequest = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<OdspRecentFilesRequest, OdspRecentFilesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ODSP_RECENT_FILE.LOAD_PENDING':
      return setPending();
    case 'ODSP_RECENT_FILE.LOAD_FULFILLED':
      return setFulfilled(action.payload.odspRecentFiles);
    case 'ODSP_RECENT_FILE.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
